module.exports = __webpack_public_path__ + "img/MD.6b8abcb3.svg";